import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { DataService } from "../../services/data-service";
import { useStoreActions } from "../../store/data-store";
const LoginPage = () => {

    const [userName, setUserName] = useState("")
    const [password, setPassword] = useState("");

    const setLoggedIn = useStoreActions(store => store.setLoggedIn);
    const setUser = useStoreActions(store => store.setUser);

    const navigate = useNavigate();


    const login = (e:React.SyntheticEvent) => {

        async function loginAsync() {
            const dataService = new DataService();
            const user = await dataService.login(userName, password);
            setUser(user);
            setLoggedIn(true);
            navigate("/projects");

        }
        e.preventDefault();
        loginAsync();
    }

    return (
        <div className="page-section  login-section">
            <form onSubmit={login}>
            <div className="section-title">Login</div>
            <div className="data-section">
                <div className="input-field">
                    <label>UserName</label>
                    <input className="form-input" autoFocus onChange={(e) => setUserName(e.currentTarget.value)} value={userName} />
                </div>
                <div className="input-field">
                    <label>Password</label>
                    <input type="password" className="form-input" onChange={(e) => setPassword(e.currentTarget.value)} value={password}/>
                </div>
            </div>
            <div className="action-section">
                <button type="submit">Login</button>
            </div>
            </form>
        </div>
    )
}
export default LoginPage